import {
  REFRESH_PAGE
} from "../constants";

export const refreshPage = () => {
  return {
    type: REFRESH_PAGE
  }
};